import axios from 'axios';

import { handleError } from '@/shared/services/api';

export default {
  baseUrl() {
    return `${window.api_url}/manager/providers`;
  },

  get(id, success) {
    if (!success) return axios.get(`${this.baseUrl()}/${id}`).catch(handleError);
    return axios.get(`${this.baseUrl()}/${id}`).then(success);
  },

  index(filters = {}) {
    return axios.get(this.baseUrl(), { params: filters }).catch(handleError);
  },

  assessment_program: {
    baseUrl(providerId) {
      return `${window.api_url}/manager/providers/${providerId}/assessment_programs`;
    },

    index(providerId) {
      return axios.get(this.baseUrl(providerId));
    },
  },

  asset: {
    baseUrl(providerId, id) {
      let url = `${window.api_url}/manager/providers/${providerId}/assets`;
      if (id) {
        url += `/${id}`;
      }
      return url;
    },

    create(providerId, asset) {
      return axios.post(this.baseUrl(providerId), { asset }).catch(handleError);
    },

    destroy(providerId, id, success) {
      axios.delete(this.baseUrl(providerId, id)).then(success);
    },

    index(providerId, filters, success) {
      axios.get(this.baseUrl(providerId), { params: filters }).then(success);
    },
  },

  dashboard: {
    baseUrl(providerId) {
      return `${window.api_url}/manager/providers/${providerId}/dashboard`;
    },

    get(providerId, subsidyProgramId) {
      return axios.get(this.baseUrl(providerId), {
        params: { subsidy_program_id: subsidyProgramId },
      });
    },
  },

  enrollmentStep: {
    baseUrl(providerId, id) {
      let url = `${window.api_url}/manager/providers/${providerId}/enrollment_steps`;
      if (id) {
        url += `/${id}`;
      }
      return url;
    },

    create(providerId, step, success, failure) {
      axios.post(this.baseUrl(providerId), { enrollment_step: step }).then(success).catch(failure);
    },

    destroy(providerId, id, success) {
      axios.delete(this.baseUrl(providerId, id)).then(success);
    },

    index(providerId, success) {
      axios.get(this.baseUrl(providerId)).then(success);
    },

    update(providerId, id, step) {
      return axios
        .patch(this.baseUrl(providerId, id), { enrollment_step: step })
        .catch(handleError);
    },
  },

  form: {
    baseUrl(providerId, id, endpoint = '') {
      let url = `${window.api_url}/manager/providers/${providerId}/forms`;
      if (id) url += `/${id}`;
      if (endpoint) url += `/${endpoint}`;
      return url;
    },

    createPayload(value) {
      return { form: value };
    },

    async create(providerId, createObject, successCallback = null, failureCallback = null) {
      return axios
        .post(this.baseUrl(providerId), this.createPayload(createObject))
        .then((response) => {
          if (successCallback) successCallback(response);
          return response;
        })
        .catch((error) => {
          if (failureCallback) return failureCallback(error);
          return handleError(error);
        });
    },

    get(providerId, id, success) {
      if (!success) return axios.get(this.baseUrl(providerId, id)).catch(handleError);

      return axios.get(this.baseUrl(providerId, id));
    },

    index(providerId, filters = {}) {
      return axios.get(this.baseUrl(providerId), { params: filters }).catch(handleError);
    },

    async update(
      providerId,
      id,
      updateObject,
      configOptions = {},
      successCallback = null,
      failureCallback = null,
    ) {
      return axios
        .patch(this.baseUrl(providerId, id), this.createPayload(updateObject), { configOptions })
        .then((response) => {
          if (successCallback) successCallback(response);
          return response;
        })
        .catch((error) => {
          if (failureCallback) return failureCallback(error);
          return handleError(error);
        });
    },

    async associate(providerId, id, data, successCallback = null, failureCallback = null) {
      return axios
        .patch(this.baseUrl(providerId, id, 'associate'), this.createPayload(data))
        .then((response) => {
          if (successCallback) successCallback(response);
          return response;
        })
        .catch((error) => {
          if (failureCallback) return failureCallback(error);
          return handleError(error);
        });
    },

    downloadUrl(providerId, id, locale, filename) {
      return `${this.baseUrl(providerId, id)}.pdf?locale=${locale}&filename=${encodeURIComponent(filename)}.pdf`;
    },
  },
};
